import KriteriaMonitoring from '../assets/images/kriteria-monitoring.png';
import TrenPersentase from '../assets/images/tren-persentase.png';
import TabelAnalisaVendor from '../assets/images/tabel-analisa-vendor.png';
import TrukTerburuk from '../assets/images/worst-truck.png';

export const paragraphsMainId = [
  [
    {
      text: 'Pada tahun 2024, Accelego memperkenalkan sistem grading otomatis (AGATE) berbasis AI untuk meningkatkan akurasi dan efisiensi sortir Tandan Buah Segar (TBS) kelapa sawit. Sistem ini mampu mendeteksi tingkat kematangan, berat di bawah 5 kg, tangkai panjang, dan kerusakan akibat hama secara real-time.',
    },
  ],
  [
    {
      text: 'Dengan fitur auto-reject, mesin dapat memisahkan TBS yang layak dan tidak layak diterima secara otomatis, menjadikan proses sortir lebih konsisten dan efisien dibandingkan metode manual.',
    },
  ],
  [
    {
      text: 'KDA merupakan salah satu pabrik kelapa sawit di Indonesia yang masih mengandalkan proses sortir TBS secara manual oleh operator grading.',
      highlight: true,
    },
  ],
  [
    { text: 'Dengan volume penerimaan mencapai ' },
    { text: '1.200 ton per hari', highlight: true },
    {
      text: ', pemeriksaan TBS satu per satu menjadi sulit dilakukan secara akurat dan konsisten.',
    },
  ],
  [
    {
      text: 'KDA memiliki komitmen untuk terus meningkatkan hasil minyak (OER) dari setiap TBS yang diolah.',
      highlight: true,
    },
    {
      text: ' Berdasarkan studi internal, potensi peningkatan OER masih terbuka lebar jika pabrik dapat ',
    },
    { text: 'meningkatkan proporsi TBS matang', highlight: true },
    { text: ' serta ' },
    {
      text: 'mengurangi TBS mentah, TBS kecil, janjang kosong, dan tangkai panjang',
      highlight: true,
    },
    { text: ' yang masuk ke proses pengolahan.' },
  ],
  [
    { text: 'Sebagai langkah strategis, KDA mengimplementasikan mesin ' },
    { text: 'AGATE', highlight: true },
    { text: ' untuk melakukan ' },
    { text: '100% sortasi otomatis', highlight: true },
    { text: ' pada area penerimaan TBS luar.' },
  ],
  [
    { text: 'Hasilnya, dalam ' },
    { text: 'empat bulan sejak implementasi', highlight: true },
    {
      text: ', data OER month to date menunjukkan peningkatan signifikan hingga 2,5%, mencerminkan dampak langsung dari peningkatan kualitas bahan baku yang diolah.',
    },
  ],
];

export const paragraphsMainEng = [
  [
    {
      text: 'In 2024, Accelego introduced an AI-powered automatic grading system (AGATE) designed to enhance the accuracy and efficiency of sorting Fresh Fruit Bunches (FFB) ',
      highlight: true,
    },
    {
      text: 'in the palm oil industry. The system can detect ripeness levels, fruit bunches weighing under 5 kg, long stalks, and pest-related damage in real time.',
    },
  ],
  [
    {
      text: 'Equipped with an auto-reject feature, the machine automatically separates acceptable and unacceptable FFB, making the sorting process more consistent and efficient compared to manual methods.',
    },
  ],
  [
    {
      text: 'KDA is one of the palm oil mills in Indonesia that previously relied on manual grading by operators to sort Fresh Fruit Bunches (FFB).',
      highlight: true,
    },
  ],
  [
    { text: 'With daily FFB intake reaching ' },
    { text: '1.200 tons', highlight: true },
    {
      text: ', manual inspection of each bunch presents significant challenges in maintaining accuracy and consistency.',
    },
  ],
  [
    { text: 'Committed to maximizing its ' },
    {
      text: 'Oil Extraction Rate (OER)',
      highlight: true,
    },
    {
      text: ', KDA identified—through internal studies—that improvements could be achieved by increasing the proportion of ripe FFB and reducing the intake of unripe, undersized bunches, empty bunches, and long stalks.',
    },
  ],
  [
    { text: 'As a strategic move, KDA implemented the ' },
    { text: 'AGATE machine ', highlight: true },
    { text: 'to enable ' },
    { text: '100% automated sorting ', highlight: true },
    { text: 'at the external FFB receiving area.' },
  ],
  [
    { text: 'Within four months', highlight: true },
    { text: ', OER month-to-date data showed a significant ' },
    { text: '2.5% increase', highlight: true },
    {
      text: ', reflecting the direct impact of improved raw material quality.',
    },
  ],
];

export const mesinSpecsId = [
  {
    label: 'Dimensi Mesin',
    value: `Panjang: 8500 mm\nLebar: 3400 mm\nTinggi: 3900 mm`,
  },
  {
    label: 'Kecepatan Mesin',
    value: '20 meter per menit',
    highlight: true,
  },
  {
    label: 'Kapasitas Mesin',
    value: '20 - 30 ton per jam',
  },
  {
    label: 'Rating Power',
    value: '12 kWh',
    highlight: true,
  },
  {
    label: 'Part Mekanikal',
    value: `Hopper\nConveyor\nScrew conveyor\nGrading box\nRumah panel`,
  },
  {
    label: 'Komposisi Grading Box',
    value: `Kamera industrial\nLampu grading`,
    highlight: true,
  },
  {
    label: 'Komposisi Rumah Panel',
    value: `Panel listrik\nCPU komputer`,
  },
];

export const mesinSpecsEng = [
  {
    label: 'Machine Dimension',
    value: `Length: 8500 mm\nWidth: 3400 mm\nHeight: 3900 mm`,
  },
  {
    label: 'Machine Speed',
    value: '20 meter per minute',
    highlight: true,
  },
  {
    label: 'Machine Capacity',
    value: '20 - 30 ton per hour',
  },
  {
    label: 'Rating Power',
    value: '12 kWh',
    highlight: true,
  },
  {
    label: 'Mechanical Part',
    value: `Hopper\nConveyor\nScrew conveyor\nGrading box\nPanel house`,
  },
  {
    label: 'Grading Box',
    value: `Industrial camera\nGrading illumination`,
    highlight: true,
  },
  {
    label: 'Panel House',
    value: `Electrical panel\nHigh GPU CPU`,
  },
];

export const agateProcessParagraphs1Id = [
  [
    {
      text: 'Proses dimulai dengan truk yang menimbang berat bruto di jembatan timbang. Selanjutnya, truk memasuki area grading dan parkir di depan hopper mesin AGATE.',
    },
  ],
  [
    {
      text: 'Petugas SPSI atau anggota KDA bertugas menurunkan TBS dan menyusun buah ke dalam conveyor mesin AGATE. Untuk mencapai akurasi optimal, setiap janjang disarankan disusun ',
    },
    {
      text: '1 janjang per kolom',
      highlight: true,
    },
    {
      text: ' sebelum diproses oleh mesin.',
    },
  ],
];

export const agateProcessParagraphs1Eng = [
  [
    {
      text: "The process begins with the truck weighing its gross load at the weighbridge. It then proceeds to the grading area and parks in front of the AGATE machine's hopper.",
    },
  ],
  [
    {
      text: 'SPSI personnel or KDA staff are responsible for unloading the FFB and arranging them onto the AGATE conveyor. For optimal accuracy, it is recommended that each bunch be placed one per column before processing.',
    },
  ],
];

export const agateProcessParagraphs2Id = [
  [
    {
      text: 'Setelah disusun pada conveyor, TBS akan melewati ',
    },
    {
      text: 'grading box',
      highlight: true,
    },
    {
      text: ' yang dilengkapi teknologi ',
    },
    {
      text: 'Artificial Intelligence (AI)',
      highlight: true,
    },
    {
      text: ' untuk memeriksa kriteria kematangan, ukuran buah, dan ukuran tangkai.',
    },
  ],
  [
    {
      text: 'Jika TBS tidak memenuhi standar kelayakan, ',
    },
    {
      text: 'pintu sliding akan terbuka',
      highlight: true,
    },
    {
      text: ' untuk memisahkan TBS yang tidak layak ke sisi samping mesin AGATE.',
    },
  ],
  [
    {
      text: 'Sementara itu, TBS yang layak diterima langsung diarahkan ke ',
    },
    {
      text: 'loading ramp',
      highlight: true,
    },
    {
      text: ' pabrik untuk proses pengolahan. TBS yang tidak layak dikembalikan ke truk dan akan ditimbang ulang guna mendapatkan berat netto muatan TBS yang diterima pabrik.',
    },
  ],
];

export const agateProcessParagraphs2Eng = [
  [
    {
      text: 'Once arranged on the conveyor, the FFB pass through the grading box, which is equipped with Artificial Intelligence (AI) to assess ripeness, fruit size, and stalk length.',
    },
  ],
  [
    {
      text: 'If a bunch does not meet the acceptance criteria, a sliding gate opens to divert it to the side of the AGATE machine. Accepted FFB are sent directly to the mill’s loading ramp for processing, while rejected bunches are returned to the truck and reweighed to determine the net weight of the accepted load.',
    },
  ],
];

export const agateProcessParagraphs3Id = [
  [
    {
      text: 'Dengan penerapan auto sorting menggunakan mesin AGATE, proses pemilahan TBS menjadi lebih ketat dan selektif. Setelah instalasi, jumlah TBS reject meningkat rata-rata dari ',
    },
    {
      text: '3% ',
      highlight: true,
    },
    {
      text: 'menjadi ',
    },
    {
      text: '25% ',
      highlight: true,
    },
    {
      text: 'terdiri dari ',
    },
    {
      text: '13% TBS mentah, 11% TBS di bawah 5 kg, dan 0,5% janjang kosong.',
      highlight: true,
    },
  ],
  [
    {
      text: 'Namun, komposisi TBS matang yang diolah meningkat menjadi ',
    },
    {
      text: '81%, dengan 19% TBS lewat matang. ',
      highlight: true,
    },
    {
      text: 'Kondisi ini menghasilkan transparansi bahan baku yang lebih baik dan mendukung peningkatan hasil ekstraksi minyak secara signifikan dibandingkan metode manual.',
    },
  ],
  [
    {
      text: 'Data pemeriksaan truk yang dilakukan oleh mesin AGATE langsung terhubung ke dashboard interaktif yang dapat diakses manajemen pusat. Melalui dashboard ini, manajemen dapat memantau komposisi TBS yang diolah setiap hari dan melakukan evaluasi terhadap truk atau vendor yang sering mengirimkan TBS dengan kualitas rendah.',
    },
  ],
];

export const agateProcessParagraphs3Eng = [
  [
    {
      text: "With the implementation of AGATE's auto-sorting system, the FFB screening process has become significantly stricter and more selective. Following installation, the average rejection rate rose from ",
    },
    {
      text: '3% ',
      highlight: true,
    },
    {
      text: 'to ',
    },
    {
      text: '25%',
      highlight: true,
    },
    {
      text: ', comprising ',
    },
    {
      text: '13% unripe FFB, 11% FFB under 5 kg, and 0.5% empty bunches.',
      highlight: true,
    },
  ],
  [
    {
      text: 'As a result, the proportion of ',
    },
    {
      text: 'ripe FFB ',
      highlight: true,
    },
    {
      text: 'processed increased to ',
    },
    {
      text: '81%',
      highlight: true,
    },
    {
      text: ', with ',
    },
    {
      text: '19% overripe ',
      highlight: true,
    },
    {
      text: 'leading to improved raw material transparency and a significant boost in oil extraction performance compared to manual grading.',
    },
  ],
  [
    {
      text: 'Inspection data from the AGATE machine is automatically integrated into an interactive ',
    },
    {
      text: 'dashboard ',
      highlight: true,
    },
    {
      text: 'accessible by central management. This enables real-time monitoring of daily FFB composition and facilitates evaluation of trucks or vendors consistently delivering substandard quality.',
    },
  ],
];

export const imageDataId = [
  {
    src: KriteriaMonitoring,
    alt: 'Kriteria kematangan & vendor monitoring',
    caption: 'Kriteria kematangan & vendor monitoring',
  },
  {
    src: TrenPersentase,
    alt: 'Tren persentase TBS diterima, ditolak & didenda',
    caption: 'Tren persentase TBS diterima, ditolak & didenda',
  },
  {
    src: TabelAnalisaVendor,
    alt: 'Tabel analisa kinerja vendor',
    caption: 'Tabel analisa kinerja vendor',
  },
  {
    src: TrukTerburuk,
    alt: 'Tabel 10 truk terburuk',
    caption: 'Tabel 10 truk terburuk',
  },
];

export const imageDataEng = [
  {
    src: KriteriaMonitoring,
    alt: 'Monitoring of vendor and ripeness criteria',
    caption: 'Monitoring of vendor and ripeness criteria',
  },
  {
    src: TrenPersentase,
    alt: 'Trends in FFB acceptance, rejection & penalty rates',
    caption: 'Trends in FFB acceptance, rejection & penalty rates',
  },
  {
    src: TabelAnalisaVendor,
    alt: 'Vendor performance evaluation table',
    caption: 'Vendor performance evaluation table',
  },
  {
    src: TrukTerburuk,
    alt: 'Table 10 worst trucks',
    caption: 'Table 10 worst trucks',
  },
];

export const accuracyParagraphs1Id = [
  [
    {
      text: 'Berdasarkan pengujian komisioning TBS luar, AI AGATE mencapai akurasi maksimum rata-rata sebesar ',
    },
    {
      text: '97%',
      highlight: true,
    },
    {
      text: '. Metode pengujian melibatkan pengumpulan sampel TBS yang seimbang per kriteria, yang telah diverifikasi oleh tim ahli KDA sebelum dimasukkan ke mesin untuk pengujian akurasi.',
    },
  ],
];

export const accuracyParagraphs1Eng = [
  [
    {
      text: 'Based on external FFB commissioning tests, AGATE’s AI achieved an average maximum accuracy of ',
    },
    {
      text: '97%',
      highlight: true,
    },
    {
      text: '. The testing method involved collecting balanced FFB samples across all criteria, each verified by KDA’s expert team prior to being processed by the machine for accuracy assessment.',
    },
  ],
];

export const accuracyParagraphs2Id = [
  [
    {
      text: 'Mesin AGATE terbukti sangat membantu pabrik kelapa sawit, khususnya yang menerima lebih dari 30% TBS luar. Keberhasilan implementasi di KDA menunjukkan bahwa area sortasi TBS merupakan bagian vital yang berdampak signifikan pada peningkatan output ekstraksi minyak.',
    },
  ],
  [
    {
      text: 'Kualitas TBS yang terjaga dengan baik melalui mesin AGATE menunjukkan korelasi positif dengan kenaikan hasil ekstraksi minyak pabrik.',
    },
  ],
];

export const accuracyParagraphs2Eng = [
  [
    {
      text: 'The AGATE machine has proven to be highly beneficial for palm oil mills, especially those receiving more than 30% external FFB. The successful implementation at KDA demonstrates that the FFB sorting area is a critical part of the mill, significantly impacting oil extraction output.',
    },
  ],
  [
    {
      text: 'Maintaining high-quality FFB through AGATE shows a positive correlation with increased oil extraction yields.',
    },
  ],
];

export const evaluationDataId = [
  {
    no: 1,
    classification: 'Mentah',
    sample: 90,
    precision: '100%',
    recall: '100%',
    f1: '100%',
    remarks:
      'Akurat dan sensitif terhadap buah mentah hitam, mentah restan membrondol, dan mentah yang memiliki sedikit warna ungu tua.',
  },
  {
    no: 2,
    classification: 'Matang',
    sample: 90,
    precision: '97%',
    recall: '100%',
    f1: '98,36%',
    remarks:
      'Strict terhadap buah matang yang memiliki warna merah ungu, merah cerah, merah orange dan merah yang sudah membrondol.',
  },
  {
    no: 3,
    classification: 'Lewat Matang',
    sample: 86,
    precision: '100%',
    recall: '88%',
    f1: '93,83%',
    remarks: '-',
  },
  {
    no: 4,
    classification: 'Janjang Kosong',
    sample: 90,
    precision: '93%',
    recall: '100%',
    f1: '96,26%',
    remarks:
      'Engine sensitif dan strict walaupun tampilan buah masih terlihat beberapa brondolan dalam.',
  },
  {
    no: 5,
    classification: 'Tangkai Panjang',
    sample: 90,
    precision: '100%',
    recall: '90%',
    f1: '94,74%',
    remarks:
      'Engine mendeteksi tangkai panjang dari pangkal/ leher buah dengan estimasi >3cm.',
  },
  {
    no: 6,
    classification: 'Buah Kecil <5kg',
    sample: 90,
    precision: '100%',
    recall: '100%',
    f1: '100%',
    remarks:
      'Engine menghitung ukuran dimensi buah untuk mengonversi perkiraan berat buah. Namun apabila buah tersebut terdeteksi lewat matang, maka akan mengurangi konversi perkiraan berat buah.',
  },
];

export const evaluationDataEng = [
  {
    no: 1,
    classification: 'Unripe',
    sample: 90,
    precision: '100%',
    recall: '100%',
    f1: '100%',
    remarks:
      'Accurate and sensitive to black unripe fruit, restan unripe fruit, and unripe fruit with slight dark purple coloring.',
  },
  {
    no: 2,
    classification: 'Ripe',
    sample: 90,
    precision: '97%',
    recall: '100%',
    f1: '98,36%',
    remarks:
      'Strict with ripe fruit that has reddish-purple, bright red, orange-red coloring, and ripe loose fruit.',
  },
  {
    no: 3,
    classification: 'Overripe',
    sample: 86,
    precision: '100%',
    recall: '88%',
    f1: '93,83%',
    remarks: '-',
  },
  {
    no: 4,
    classification: 'Empty Bunch',
    sample: 90,
    precision: '93%',
    recall: '100%',
    f1: '96,26%',
    remarks:
      'An engine that is sensitive and strict, even when the fruit still shows some inner loose spikelets (brondolan) visible.',
  },
  {
    no: 5,
    classification: 'Long Stash',
    sample: 90,
    precision: '100%',
    recall: '90%',
    f1: '94,74%',
    remarks:
      'The engine detects long stalks from the base/neck of the fruit with an estimated length of over 3 cm.',
  },
  {
    no: 6,
    classification: 'TBS <5kg',
    sample: 90,
    precision: '100%',
    recall: '100%',
    f1: '100%',
    remarks:
      "The engine calculates the fruit's dimensional size to estimate its weight. However, if the fruit is detected as overripe, the estimated weight conversion will be reduced accordingly.",
  },
];

export const totalSample = 536;
export const avgF1Score = '97%';
